// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config_section_section .el-form-item__label{font-size:13px}", ""]);
// Exports
module.exports = exports;
